module.exports = __webpack_public_path__ + "static/media/logo.0ea698b5.png";